angular.module('iqxCore')
.controller('CandidatePayslipsCtrl', function ($scope, FormSvc, $http, $routeParams, ApiSvc, LanguageSvc) {
    let openPaySlipFromID = (id) => {
        id = id.split("_")
        let samePayRoll = findIn($scope.PaySlips, id[0])
        let payslip = findIn(samePayRoll, id[1])
        return $scope.view(payslip[0].PayslipPath, payslip[0].PayrollNumber)
    }

    const findIn = (arr, searchKey) => {
        return arr.filter(obj => 
            Object.keys(obj).some(key => {
                if (typeof obj[key] === 'string') {
                    return obj[key].includes(searchKey)
                }
            })
        )
    }

    FormSvc.setOptions($scope,{
      fetchAPI:'callresult/NetCandidatePayslipList',
      fetchTarget:'PaySlips',
      multiRow:true,
      dateFields:['PayslipDate']
    })
    $scope.fetch()
    .then( () => {
        $scope.PaySlips.forEach((element, key) => {
            $scope.PaySlips[key]['dateFormatted'] = moment($scope.PaySlips[key]['PayslipDate']).format('DD-MM-YYYY')
        })
        if($routeParams.id){
            // /candidatepayslips/<PayrollNumber>_<PayslipDate>
            openPaySlipFromID($routeParams.id)
        }
    })
    var lang = LanguageSvc.lang

    $scope.download=function(payslipPath){
    	/* Triggers the download */
    	$scope.getFile(payslipPath, "download")
    }

    $scope.view=function(payslipPath, title){
    	title=title||""
    	$scope.getFile(payslipPath, "view", title)
    }

    $scope.query=function(payslip){
    	var data={}
    	FormSvc.modalForm($scope, 'queryPaySlip', data, 'md', {label:'col-sm-3', data:'col-sm-7'}, $scope.tags)
    	.then(function(data){
    		return ApiSvc.fetch(
    			$scope,
    			{
    				fetchAPI:'callresult/NetCandidateCreatePopup?pConsultantID='+payslip.ConsultantID+'&pPayrollNumber='+payslip.PayrollNumber+'&pComment='+encodeURIComponent(data.xQuery), 
    				fetchTarget:'createPopup',
    				multiRow:false
    			}
    		)
    	})
    	.then(function(){
    		FormSvc.alert("Query Sent", "Your message has been sent.", "success")
    	})
        .catch(function(err){
            // ignore
        })
    }

    $scope.getFile=function(pathname, method, payslipTitle){
        if (method == 'download') {
            if ($scope.isApp !== true && $scope.isWebView !== true) {
                var _newTab = window.open('about:blank', '_blank')
            }
        }        
    	$http.get('/api/document/doxi',{params:{path:pathname}})
    	.then(function(res){
    		$http.get('/api/document/download?doxi='+res.data)
            .then(function(success){
                switch(method){
                    case 'download':                        
                        setTimeout(function () { // wait a second then fill that blank tab - thus stopping that pesky popup blocker!!
                            if ($scope.isApp !== true && $scope.isWebView !== true) {
                                _newTab.location.href = '/api/document/download?doxi=' + res.data
                            } else {
                                window.open('/api/document/download?doxi=' + res.data, '_blank')
                            }
                        }, 100)
                    break

                    case 'view':
                        $scope.title=payslipTitle || ""
                        $scope.PDFcontent = '/api/document/download?doxi='+res.data
                        FormSvc.modalInfo($scope,'viewPaySlip',{choices:[{desc:"Close",type:"primary",code:''}]}, 'lg')
                    break
                }
            }, function(error){
                var payslipError = "Error ["+error.status+"] " + error.data +"\n\r"+ "The document cannot be reached at the moment." +"\n\r"+lang.candidate.payslipserror
                FormSvc.alert("Error", payslipError, "error")
            })
		})
		.catch(function(err) {
			FormSvc.alert("Error", err.data, "error")
		})
    }
})